export const API_BASE_URL = process.env.API_BASE_URL ?? '';
export const SUB_URL_USERS = '/apis/users';
export const PG_USER_WEB = '/apis/pg-user-web';

export const ApiPath = {
	USER_SUMMARY: `${SUB_URL_USERS}/v3/summary`,
	USER_CARDS: `${PG_USER_WEB}/v1/user-dashboard/cards`,
	DELETE_USER_CARD: `${PG_USER_WEB}/v1/user-dashboard/cards/{MERCHANT_ID}/{CARD_ID}`,
};
